import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onAuthorize", "provider"];
import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl-next';
import { messages } from '../../../messages';
import { ActionButton } from '../../InlineCard/common/action-button';
import Hyperlink from '../Hyperlink';
var HyperlinkUnauthorizedView = function HyperlinkUnauthorizedView(_ref) {
  var onAuthorize = _ref.onAuthorize,
    provider = _ref.provider,
    props = _objectWithoutProperties(_ref, _excluded);
  var actionButton = useMemo(function () {
    return onAuthorize ? /*#__PURE__*/React.createElement(ActionButton, {
      onClick: onAuthorize,
      testId: "button-connect-account"
    }, /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.connect_link_account_card_name, {
      values: {
        context: provider === null || provider === void 0 ? void 0 : provider.text
      }
    }))) : null;
  }, [onAuthorize, provider === null || provider === void 0 ? void 0 : provider.text]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Hyperlink, props), actionButton);
};
export default HyperlinkUnauthorizedView;